<div class="app-shell lifeislife-simple-app-shell">
  <cf-shell-messages></cf-shell-messages>

  <header [routerLink]="['/products']" tabindex="-1">
    <div class="left"></div>

    <div class="logo">
    </div>

    <h1>
      LifeisLife
    </h1>
    <div class="right">
      <div class="spacer"></div>
      <cf-logged-user-menu></cf-logged-user-menu>
    </div>
  </header>

  <!-- Some modal banners -->
  <div class="modal-banners" *ngIf="routeContentVisible$ | async">
    <cf-shell-banners></cf-shell-banners>
  </div>

  <div class="content">


    <!-- Some modals are displayed here in place of the navigtion route -->
    <router-outlet
      *ngIf="routeContentVisible$ | async"
      (activate)="onActivateRoute($event)"
      (deactivate)="onDeactiveRoute($event)">
      <div class="loading-bloc lifeislife-loading-bloc" *ngIf="!routeActive">
        <div class="logo">
          <div class="loader"></div>
          <div class="image"></div>
        </div>
        <h1>
          Chargement...
        </h1>
      </div>
    </router-outlet>

    <div *ngIf="userPasswordModalVisible$ | async"
         class="password-modal">
      <cf-user-password-modal (success)="onPasswordResetSuccess()"
      ></cf-user-password-modal>
      <div class="ignore-link">
        <a class="ignore" (click)="onPasswordResetCancel()">
          Ignorer
        </a>
      </div>
    </div>

    <div *ngIf="contactSelectionModalVisible$ | async"
         class="customer-contact-modal">
      <cf-customer-contact-select-modal></cf-customer-contact-select-modal>
    </div>

  </div>

  <llc-lifeislife-footer></llc-lifeislife-footer>
</div>
